import { render, staticRenderFns } from "./PanelAlpha.vue?vue&type=template&id=6ccb0b14&scoped=true&lang=pug&"
import script from "./PanelAlpha.vue?vue&type=script&lang=js&"
export * from "./PanelAlpha.vue?vue&type=script&lang=js&"
import style0 from "./PanelAlpha.vue?vue&type=style&index=0&id=6ccb0b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccb0b14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ccb0b14')) {
      api.createRecord('6ccb0b14', component.options)
    } else {
      api.reload('6ccb0b14', component.options)
    }
    module.hot.accept("./PanelAlpha.vue?vue&type=template&id=6ccb0b14&scoped=true&lang=pug&", function () {
      api.rerender('6ccb0b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrowFSFB/components/PanelAlpha.vue"
export default component.exports